module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/4-068a812100a2f70808f88c9fdf061d02.jpg";